import React, { useState, useCallback } from 'react'
import { ModalBody } from 'reactstrap'
import { ValidationBoundary, ValidationState, Validator } from '@/components/validation'
import { BasicHeader } from '@/dialogs/common/basicHeader'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { Input } from '@/components/inputs'
import ErrorBoundary from '@/components/ErrorBoundary'

const EditLegacyCodeDialog = (props) => {
  const [legacyCode, setLegacyCode] = useState(props.legacyCode || '')
  const handleChange = useCallback(e => setLegacyCode(e.target.value), [setLegacyCode])
  return (
    <ValidationBoundary>
      <BasicHeader title='Common.LegacyCode' {...props} />
      <ModalBody>
        <ErrorBoundary>
          <Validator name='legacyCode' value={legacyCode} maxLength={30}>
            <Input id='legacyCode' onChange={handleChange} value={legacyCode} />
          </Validator>
        </ErrorBoundary>
      </ModalBody>
      <ValidationState render={({ isValid }) =>
        <ConfirmFooter primaryButtonText='Common.SaveAndClose' icon='save' {...props} onAction={() => props.onAction(legacyCode)} disabled={!isValid} />
      } />
    </ValidationBoundary>
  )
}

export default {
  component: EditLegacyCodeDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/editLegacyCode.js